import { Reducer } from 'redux'
import { PartnerStaffState, PartnerStaffTypes, PartnerStaffActionTypes } from './types'

const initialState: PartnerStaffState = {
  staff: [],
  labels: {
    OWNER: 'Proprietário',
    DELIVERYMAN: 'Entregador',
    COOKER: 'Cozinheiro',
    CLERK: 'Vendedor',
    MANAGER: 'Gerente'
  }
}

type ReducerOpts = Reducer<PartnerStaffState, PartnerStaffActionTypes>
const reducer: ReducerOpts = (state = initialState, action: PartnerStaffActionTypes): PartnerStaffState => {
  let index = -1
  switch (action.type) {
    case PartnerStaffTypes.PARTNER_STAFF_CREATE:
      return { ...state, staff: [...state.staff, action.payload] }
    case PartnerStaffTypes.PARTNER_STAFF_DELETE:
      index = state.staff.findIndex(item => item.id === action.payload)
      return {
        ...state,
        staff: [
          ...state.staff.slice(0, index),
          ...state.staff.slice(index + 1)
        ]
      }
    case PartnerStaffTypes.PARTNER_STAFF_TIME_TABLE:
      index = state.staff.findIndex(item => item.id === action.payload.id)
      return {
        ...state,
        staff: [
          ...state.staff.slice(0, index),
          action.payload,
          ...state.staff.slice(index + 1)
        ]
      }
    case PartnerStaffTypes.PARTNER_STAFF_GET_LIST:
      return { ...state, staff: action.payload }
    default:
      return state
  }
}

export default reducer
